import request from "@/services/request";
import baseUrl from "@/services/baseUrl";

const ucBo = `${baseUrl.uc}/uc/v1/bo`;

export default {
  getUsers: (params = {}) => request.post(`${ucBo}/list`, params),
  createUser: (params = {}) => request.post(`${ucBo}/new`, params),
  updateUser: (params = {}) => request.put(`${ucBo}/user`, params),
  deleteUser: userId => request.post(`${ucBo}/delete/${userId}`),
  helpResetPassword: (params = {}) => request.post(`${ucBo}/help-staff-reset-password`, params),
  getSecuritySettings: () => request.get(`${ucBo}/security/settings`),
  updateSecuritySettings: (params = {}) => request.put(`${ucBo}/security/settings`, params),
  updateStaffTwoFactor: (userId, params = {}) => request.put(`${ucBo}/${userId}/two-factor`, params),
  resetAuthenticator: userId => request.post(`${ucBo}/${userId}/authenticator/reset`, {}),
};
